import { clsx } from 'clsx'
import { type FC, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

import { useHideAddToCart } from '../ProductBuyBox/useHideAddToCart'
import { useProductPageShouldHidePackSizeSelectorForExpa } from '../ProductBuyBox/useProductPageShouldHidePackSizeSelectorForExpa'
import { useProductPageContext } from '../productPageContext'

import { ProductPageAttributeSelectionGroupRenderer } from './ProductPageAttributeSelectionGroupRenderer'
import { ProductPageAttributeGroupDivider } from './ProductPageAttributeSelectionGroupRenderer/ProductPageAttributeGroupDivider'

export const ProductPageAttributesSelection: FC = () => {
  const hideAddToCart = useHideAddToCart()
  const { attributeSelectionControls } = useProductPageContext()
  const { isSingleRenderGroup, renderGroups } = attributeSelectionControls

  const shouldHidePackSizeSelectorForExpa =
    useProductPageShouldHidePackSizeSelectorForExpa()

  return (
    <div
      className={clsx(
        'flex flex-col border-dark-primary-min',
        !hideAddToCart && 'border-b',
        renderGroups.length === 0 && 'pb-2.5',
      )}
    >
      {renderGroups.map((renderGroup, index) => {
        const { contactLensesGroups, group } = renderGroup

        if (group?.shouldRenderGroup) {
          const shouldHideAttributeGroupForExpa =
            shouldHidePackSizeSelectorForExpa &&
            isSingleRenderGroup &&
            group.shouldDisplayOnlySelectedValue

          if (shouldHideAttributeGroupForExpa) {
            return null
          }

          return (
            <Fragment key={group.metaAttributeData.variant_attribute}>
              {index > 0 && !group.shouldDisplayOnlySelectedValue && (
                <ProductPageAttributeGroupDivider />
              )}
              <ProductPageAttributeSelectionGroupRenderer
                attributeGroup={group}
                isSingleGroup={isSingleRenderGroup}
              />
            </Fragment>
          )
        }

        if (contactLensesGroups && contactLensesGroups.length > 0) {
          return (
            <Fragment key="contactLenseGroup">
              <ProductPageAttributeGroupDivider />
              <p className="my-2.5">
                <FormattedMessage id="variantAttributes.contactLens.regionLabel" />
              </p>
              {contactLensesGroups.map((lensesGroup) => {
                if (!lensesGroup.shouldRenderGroup) {
                  return null
                }

                return (
                  <ProductPageAttributeSelectionGroupRenderer
                    attributeGroup={lensesGroup}
                    isSingleGroup={isSingleRenderGroup}
                    key={lensesGroup.metaAttributeData.variant_attribute}
                  />
                )
              })}
            </Fragment>
          )
        }

        return null
      })}
    </div>
  )
}
